import { useCallback } from 'react';
import clsx from 'clsx';
import {
  availabilityCollectionTimeslotsLoadingSelector,
  availabilityCollectionTimeslotsSelectedTimeslotSelector,
  availabilityCollectionTimeslotsSelector,
  createUnsaveTimeslot,
  setSelectedTimeslot,
} from 'slices/availabilityCollectionTimeslot.slice';
import { useAppDispatch, useAppSelector } from 'slices/store';
import type { TAvailabilityCollectionTimeslot } from 'types/availabilityCollectionTimeslot.type';
import { Button, EditableTable } from '@timeedit/ui-components';
import { Flex, Space, Spin } from '@timeedit/ui-components/antd';
import { timeslotColumns } from './timeslotUtils';

const Timeslots = () => {
  const timeslots = useAppSelector(availabilityCollectionTimeslotsSelector);
  const isLoading = useAppSelector(
    availabilityCollectionTimeslotsLoadingSelector
  );
  const selectedTimeslot = useAppSelector(
    availabilityCollectionTimeslotsSelectedTimeslotSelector
  );
  const dispatch = useAppDispatch();

  const onCreate = useCallback(() => {
    dispatch(createUnsaveTimeslot());
  }, [dispatch]);

  const onRowClick = useCallback((record) => {
    dispatch(setSelectedTimeslot(record));
  }, []);

  const rowClassName = useCallback(
    (record: TAvailabilityCollectionTimeslot) =>
      clsx({
        ['ant-table-row-selected']:
          record && selectedTimeslot?._id === record._id,
      }),

    [selectedTimeslot]
  );

  const footer = useCallback(
    () => (
      <Flex style={{ width: '100%' }} justify="space-between">
        <Flex gap="small" justify="flex-start">
          <Button size="small" type="primary" onClick={onCreate}>
            Create new
          </Button>
        </Flex>
      </Flex>
    ),
    [onCreate]
  );

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Spin spinning={isLoading}>
        <EditableTable
          rowKey="_id"
          columns={timeslotColumns}
          dataSource={timeslots}
          footer={footer}
          rowClassName={rowClassName}
          onRow={(record) => ({
            onClick: () => onRowClick(record),
          })}
        />
      </Spin>
    </Space>
  );
};

export default Timeslots;
